//#region module
import { AppBar, Box, Grid, Paper, Tab, Tabs, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useRef } from "react";
import { useDashboardContext } from "./DashboardView";

export default function DashboardViewSheet(props) {
  const { dashboardState, changeSheet } = useDashboardContext();
  const { sheets: sheetsAvailable, currentSheetIndex: selectedSheetIndex, tabDesign } = dashboardState;
  const handleTabChange = (_, newValue) => changeSheet(newValue);
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
    appBar: {
      color: "inherit",
      backgroundColor: theme.palette.background.paper,
      boxShadow: "none",
    },
  }));

  const classes = useStyles();
  const tabsRef = useRef();

  useEffect(() => {
    if (tabsRef?.current && window.innerWidth < 1024) {
      var tabsScrollEl = tabsRef?.current?.querySelector('.MuiTabs-scroller');
      tabsScrollEl.addEventListener("scroll", (e) => {
        let currentLeftPosition = e.currentTarget.scrollLeft;
        if (currentLeftPosition === 0) {
          tabsScrollEl.classList.remove("tabs-on-scroll");
        } else {
          tabsScrollEl.classList.add("tabs-on-scroll");
        }
      });
    }

  }, [tabsRef])

  if (!sheetsAvailable || sheetsAvailable?.length <= 1) return null;

  return (
    <AppBar position="static" className={classes.appBar + ' published-dashboard-sheets'}>
      <Paper square className="publish-dashboard-tabs">
        <Grid container alignItems="center" justify="center">
          <Grid item xl={12} lg={12} md={12} sm={12} xs={12} data-class={tabDesign} className={(tabDesign && tabDesign === 'old') ? 'cr-tabs' : 'cr-tabs-2'}>
            <Tabs
              //onScroll={() => console.log("333333")}
              ref={tabsRef}
              value={selectedSheetIndex}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              TabIndicatorProps={{
                sx: {
                  backgroundColor: 'transparent',
                },
                children: <span />
              }}
              allowScrollButtonsMobile={false}
            >
              {sheetsAvailable?.length > 1
                ? sheetsAvailable?.map((tab, i) => (
                  <Tab
                    key={i}
                    className="tab-item"
                    value={tab?.id}
                    label={
                      <Grid container alignItems="center" justify="center" className="tab-item-box" >
                        <Box sx={{ width: '100%' }}>
                          <Typography variant='h5' className='tab-item-label' > {tab?.sheetName}</Typography>
                        </Box>
                      </Grid>
                    }
                  />
                )) : null}
            </Tabs>
          </Grid>
        </Grid>
      </Paper>
    </AppBar>
  );
}
